document.addEventListener("DOMContentLoaded", function () {
  // ===============================
  // GPO描画後に初期化
  // ===============================
  document.addEventListener("gpoRenderCompleted", function () {
    initPriceUI();
    initGroupSelected();
    initSwatchData();
  });

  // ===============================
  // 価格UI初期化
  // ===============================
  function initPriceUI() {
    const totalText = document.querySelector(".gpo-total .gpo-total-text");
    if (!totalText) return;

    const moneyElm = document.querySelector("product-price .price");
    if (!moneyElm) return;

    const money = moneyElm.innerHTML;

    totalText.classList.add("price-list");
    totalText.innerHTML =
      '<span class="text">合計価格： </span>' +
      '<product-price class="tprice">' +
      money +
      "</product-price>" +
      ' <small style="font-size:95%">(税込)</small>';
  }

  // ===============================
  // group-selected生成
  // ===============================
  function initGroupSelected() {
    const groupAccess = document.querySelectorAll(
      ".gpo-app .show-addon-for-option",
    );

    groupAccess.forEach(function (el) {
      if (!el.querySelector(".group-selected")) {
        el.insertAdjacentHTML(
          "beforeend",
          '<div class="group-selected">' +
            '<span class="label">選択中：</span>' +
            '<span class="value">選択されていません</span>' +
            "</div>",
        );
      }
    });
  }

  function initSwatchData() {
    const inputs = document.querySelectorAll(".gpo-app .gpo-swatches input");

    inputs.forEach(function (element) {
      const handle = element.getAttribute("gpo-data-product-handle");
      const variant_id = element.getAttribute("gpo-data-variant-id");

      if (!handle || !variant_id) return;

      getProductVariant(handle, variant_id).then(function (variant) {
        const swatch = element.closest(".gpo-swatches");
        if (!swatch) return;

        // 重複防止
        if (swatch.querySelector(".detail-access")) return;

        if (!variant.available) {
          swatch.classList.add("disabled");

          if (!swatch.querySelector(".outstock-label")) {
            swatch.insertAdjacentHTML(
              "beforeend",
              '<span class="outstock-label">在庫切れ</span>',
            );
          }
        }

        swatch.insertAdjacentHTML(
          "beforeend",
          '<a class="detail-access" target="_blank" href="' +
            variant.variant_url +
            '">' +
            '<svg fill="#000000" height="20px" viewBox="0 0 24 24" width="20px" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M15,10H12V7a1,1,0,0,0-2,0v3H7a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V12h3a1,1,0,0,0,0-2Zm6.71,10.29L18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" />' +
            "</svg>" +
            "</a>",
        );
      });
    });
  }

  async function getProductVariant(handle, variantId) {
    var product = await ProductLoader.load(handle);
    var variant = product.variants.find(function (v) {
      return v.id == variantId;
    });
    variant.variant_url = product.url + "?variant=" + variant.id;
    return variant;
  }

  var loadedProducts = {};

  function ProductLoader() {}
  ProductLoader.load = function (productHandle) {
    if (!productHandle) return;

    if (loadedProducts[productHandle]) {
      return loadedProducts[productHandle];
    }

    loadedProducts[productHandle] = new Promise(function (resolve, reject) {
      fetch(Shopify.routes.root + "products/" + productHandle + ".js")
        .then(function (response) {
          if (!response.ok) throw new Error();
          return response.json();
        })
        .then(function (json) {
          resolve(json);
        })
        .catch(function () {
          reject("product load error");
        });
    });

    return loadedProducts[productHandle];
  };

  // ===============================
  // changeイベント（1回だけ）
  // ===============================
  document.addEventListener("change", function (e) {
    const element = e.target;

    if (!element.matches(".gpo-app .gpo-swatches input")) return;

    // 金額の更新を待つ
    waitForPriceUpdate(updateTotalPrice);

    const wrap = element.closest(".gpo-ov-wrapper");
    const wrap2 = element.closest(".show-addon-for-option");

    // -------------------------------
    // UI制御
    // -------------------------------
    if (!wrap || !wrap2) return;

    let valueElm = wrap2.querySelector(".group-selected .value");

    if (!valueElm) {
      wrap2.insertAdjacentHTML(
        "beforeend",
        '<div class="group-selected">' +
          '<span class="label">選択中：</span>' +
          '<span class="value">選択されていません</span>' +
          "</div>",
      );
      valueElm = wrap2.querySelector(".group-selected .value");
    }

    const checkedInputs = wrap.querySelectorAll("input:checked");

    if (checkedInputs.length > 0) {
      const selected = checkedInputs[0];

      valueElm.innerHTML = selected.value;
      wrap2.querySelector(".group-selected").classList.remove("no-c");

      let noChoice = wrap.querySelector(".no-choice");

      if (!noChoice) {
        wrap.insertAdjacentHTML(
          "beforeend",
          '<div class="gpo-swatches image-swatches no-choice">' +
            '<a class="btn-no-choose" href="#">買わない</a>' +
            "</div>",
        );
      } else {
        noChoice.classList.remove("active");
      }
    } else {
      valueElm.innerHTML = "選択されていません";
      wrap2.querySelector(".group-selected").classList.add("no-c");

      const noChoiceElm = wrap.querySelector(".no-choice");
      if (noChoiceElm) {
        noChoiceElm.classList.add("active");
      }
    }
  });

  function waitForPriceUpdate(callback) {
    const moneyElm = document.querySelector("product-price .price");
    if (!moneyElm) return;

    const initial = moneyElm.textContent;

    let retry = 0;

    function check() {
      const current = moneyElm.textContent;

      if (current !== initial) {
        callback();
        return;
      }

      if (retry < 10) {
        retry++;
        setTimeout(check, 50);
      }
    }

    check();
  }

  function updateTotalPrice() {
    const totalText = document.querySelector(".gpo-total .gpo-total-text");
    const moneyElm = document.querySelector("product-price .price");

    if (!moneyElm || !totalText) return;

    const productPrice =
      Number(moneyElm.textContent.replace(/[^\d.-]/g, "")) || 0;

    const currency = Shopify.currency.active;
    const formatter = new Intl.NumberFormat(
      document.documentElement.lang || "en-US",
      {
        style: "currency",
        currency,
      },
    );

    const formattedTotalPrice = formatter.format(productPrice);

    totalText.innerHTML =
      '<span class="text">合計価格： </span>' +
      '<product-price class="tprice">' +
      formattedTotalPrice +
      "</product-price>" +
      ' <small style="font-size:95%">(税込)</small>';
  }

  const lastCheckedMap = new Map();

  document.addEventListener("click", function (e) {
    if (!e.target.matches(".gpo-app .gpo-swatches input[type='radio']")) return;

    const input = e.target;
    const wrap = input.closest(".gpo-ov-wrapper");
    if (!wrap) return;

    const lastChecked = lastCheckedMap.get(wrap);

    // 同じwrapper内で同じ要素 → 解除
    if (lastChecked === input) {
      input.checked = false;
      lastCheckedMap.set(wrap, null);

      input.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    // 通常選択
    lastCheckedMap.set(wrap, input);
  });

  // ===============================
  // 「買わない」ボタン（イベント委譲）
  // ===============================
  document.addEventListener("click", function (e) {
    if (!e.target.matches(".btn-no-choose")) return;

    e.preventDefault();

    const wrap = e.target.closest(".gpo-ov-wrapper");
    if (!wrap) return;

    // 全てのradioを明示的にOFF
    const inputs = wrap.querySelectorAll("input");

    inputs.forEach(function (input) {
      input.checked = false;
    });

    // UI更新を強制
    const firstInput = inputs[0];
    if (firstInput) {
      firstInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
});
